import fonts from './fonts'
import colors from './colors'
import media from './media'

export default {
  fonts,
  colors,
  media,
  borderRadius: '4px',
  boxShadow: {
    basic: '0 9px 24px 0 rgba(35,41,48,0.15)',
    hover: ''
  }
}
